import { useState, useEffect } from 'react';
import { useStore } from 'src/stores';
import { getCookieByName, setCookieByName } from 'src/core/utils';

/**
 * <userAgeProps /> props
 */

type props = {
  setIsAgeGate?: any;
};
const userAgeProps = (_: props) => {
  const {
    formStore: {
      verified,
      ageWarning,
      warning,
      warningMessage,
      setVerified,
      setAgeWarning,
      setWarning,
      setWarningMessage
    }
  } = useStore();

  const getAgeGate = data => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    const birthYear = data.year;
    const birthMonth = data.month;

    const ageYear = year - birthYear;
    const ageMonth = month - birthMonth;

    if (ageYear > 18 || (ageYear === 18 && ageMonth >= 0)) {
      setWarning(false);
      _.setIsAgeGate(true);
      document.body.classList.remove('no-scroll');
      setCookieByName('zyn-age-verified', 'yes');
    } else {
      setWarning(true);
      setWarningMessage(
        'Щоб переглядати контент цього веб-сайту, тобі повинно бути 18+ років'
      );
    }
  };

  useEffect(() => {
    document.body.classList.add('no-scroll');
    if (
      getCookieByName('zyn-age-verified') === '1' ||
      getCookieByName('zyn-age-verified') === 'yes' ||
      getCookieByName('age-verified')
    ) {
      getAgeGate({ month: 1, year: 2000 });
    } else setVerified(false);
    const param = window.location.search;

    // setSessionId();

    return () => document.body.classList.remove('no-scroll');
  }, []);

  return {
    verified,
    warning,
    getAgeGate
  };
};

export { userAgeProps };
